import React from 'react';

import { AppConstants } from '../../../libs/enums';

export const FooterComponent: React.FC = React.memo(() => (
  <footer className="fr-footer" id="footer" role="contentinfo">
    <div className="fr-container">
      <div className="fr-footer__body">
        <div className="fr-footer__brand fr-enlarge-link">
          <p className="fr-logo">
            République
            <br />
            Française
          </p>
          <img
            alt="FranceConnect, 10 ans de simplification de l’accès aux démarches"
            className="fr-footer__logo fr-footer__brand-link"
            src={`${AppConstants.PUBLIC_URL}/img/fc-logo-10-ans.svg`}
            style={{ maxWidth: '159.55px' }}
          />
        </div>
        <div className="fr-footer__content">
          <p className="fr-footer__content-desc">
            FranceConnect est le dispositif d’identification conçu par l’État pour vous faciliter
            l’accès à vos services en ligne. En utilisant un de vos comptes déjà existant vous
            pourrez vous connecter de façon sécurisée à plus de 1000 services sans créer de nouveau
            mot de passe.
          </p>
          <ul className="fr-footer__content-list">
            <li className="fr-footer__content-item">
              <a
                className="fr-footer__content-link"
                href="https://www.legifrance.gouv.fr/"
                rel="noopener noreferrer"
                target="_blank">
                legifrance.gouv.fr
              </a>
            </li>
            <li className="fr-footer__content-item">
              <a
                className="fr-footer__content-link"
                href="https://info.gouv.fr"
                rel="noopener noreferrer"
                target="_blank">
                info.gouv.fr
              </a>
            </li>
            <li className="fr-footer__content-item">
              <a
                className="fr-footer__content-link"
                href="https://service-public.fr"
                rel="noopener noreferrer"
                target="_blank">
                service-public.fr
              </a>
            </li>
            <li className="fr-footer__content-item">
              <a
                className="fr-footer__content-link"
                href="https://data.gouv.fr"
                rel="noopener noreferrer"
                target="_blank">
                data.gouv.fr
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="fr-footer__bottom">
        <ul className="fr-footer__bottom-list">
          <li className="fr-footer__bottom-item">
            <a
              className="fr-footer__bottom-link"
              href="/support/pdf/CGU_Support_Utilisateur-v1.0.pdf"
              rel="noopener noreferrer">
              Conditions générales d’utilisation
            </a>
          </li>
          <li className="fr-footer__bottom-item">
            <a
              className="fr-footer__bottom-link"
              href="https://franceconnect.gouv.fr/mentions-legales"
              rel="noopener noreferrer">
              Mentions légales
            </a>
          </li>
          <li className="fr-footer__bottom-item">
            <a
              className="fr-footer__bottom-link"
              href="https://franceconnect.gouv.fr/presse"
              rel="noopener noreferrer">
              On parle de nous
            </a>
          </li>
          <li className="fr-footer__bottom-item">
            <a
              className="fr-footer__bottom-link"
              href="https://franceconnect.gouv.fr/partenaires"
              rel="noopener noreferrer">
              Devenez partenaires
            </a>
          </li>
          <li className="fr-footer__bottom-item">
            <a
              className="fr-footer__bottom-link"
              href="https://franceconnect.gouv.fr/faq#CONTACT"
              rel="noopener noreferrer">
              Contactez nous
            </a>
          </li>
          <li className="fr-footer__bottom-item">
            <a
              className="fr-footer__bottom-link"
              href="https://franceconnect.gouv.fr/accessibilite"
              rel="noopener noreferrer">
              Accessibilité&nbsp;: non conforme
            </a>
          </li>
          <li className="fr-footer__bottom-item">
            <a
              className="fr-footer__bottom-link"
              href="https://franceconnect.gouv.fr/plan-site"
              rel="noopener noreferrer">
              Plan du site
            </a>
          </li>
          <li className="fr-footer__bottom-item">
            <a
              className="fr-footer__bottom-link"
              href="/support/pdf/PC_Support_Utilisateur_v1.1.pdf"
              rel="noopener noreferrer">
              Politique de confidentialité
            </a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
));

FooterComponent.displayName = 'FooterComponent';
